import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
// import { v4 as uuidv4 } from 'uuid'
import i18n from 'i18next'
import Panel from '../../UniformComponents/Panel'
import Button from '../../UniformComponents/Button'
// import DefaultDashboardSetter from './DefaultDashboardSetter'
import ScopeSelector from './ScopeSelector'

@observer
class DashboardHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showComparison: false,
            menuOpen: false,
        }
    }

    renderLevelSelect = () => {
        const { DynamicDashboardStore } = this.props
        const { changeLevel, getLevels, level } = DynamicDashboardStore
        const levels = getLevels()
        return Array.from(levels).map(([l, dashboard]) => (
            // eslint-disable-next-line max-len
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            <div
                style={{
                    color: level === l ? '#414BB2' : 'inherit',
                    fontWeight: 600,
                    fontSize: '16px',
                    marginRight: '30px',
                    cursor: 'pointer',
                    borderBottom: level === l ? 'solid 2px #414BB2' : 'none',

                }}
                onClick={() => changeLevel(l, dashboard)}
            >
                {l}
            </div>
        ))
    }

    toggleShowComparison = () => {
        this.setState((prevState) => ({ showComparison: !prevState.showComparison }))
    }

    toggleMenuOpen = (e) => {
        e.stopPropagation()
        const { menuOpen } = this.state

        if (!menuOpen) document.body.addEventListener('click', this.toggleMenuOpen)
        if (menuOpen) document.body.removeEventListener('click', this.toggleMenuOpen)

        this.setState({ menuOpen: !menuOpen })
    }

    renderMenu = () => {
        const { menuOpen } = this.state
        const { DynamicDashboardStore } = this.props
        return (
            <div
                className="menu"
            >
                <div
                    onClick={this.toggleMenuOpen}
                    className="menu-icon"
                    style={{
                        backgroundColor: menuOpen ? '#EDF1F7' : undefined,
                    }}
                >
                    <i className="fa-solid fa-ellipsis-vertical" />
                </div>
                <div
                    className="menu-container"
                    style={{
                        display: menuOpen ? 'block' : 'none',
                    }}
                >
                    <ul style={{
                        listStyleType: 'none', fontSize: '13px', cursor: 'pointer', height: '100%', position: 'relative', padding: '0',
                    }}
                    >
                        {DynamicDashboardStore.getMenuOptions()}
                    </ul>
                </div>
            </div>
        )
    }

    changeDashboardEditingCheck = (value) => {
        const { DynamicDashboardStore } = this.props
        const { editing, updateConfirmationModal, changeDashboard } = DynamicDashboardStore
        const confirmationModalSettings = {
            show: editing,
            onFalse: () => { DynamicDashboardStore.confirmationModal.show = false },
            title: i18n.t('dashbaords.unsavedChanges.title'),
            description: i18n.t('dashbaords.unsavedChanges.description'),
        }
        if (!editing) {
            DynamicDashboardStore.level = undefined
            changeDashboard(value)
        } else {
            confirmationModalSettings.onTrue = () => {
                DynamicDashboardStore.level = undefined
                changeDashboard(value)
                DynamicDashboardStore.editing = false
                updateConfirmationModal({ show: false })
            }
            updateConfirmationModal(confirmationModalSettings)
        }
    }

    render() {
        const {
            DynamicDashboardStore, history, surveyDash,
        } = this.props
        const {
            dashboard,
            scopeName,
            loadingScopeData,
        } = DynamicDashboardStore

        return (
            <Fragment>
                <Panel cssClass="dynamicDashboard-header">
                    {/* dashboardTitle used in downloadAsPNG */}
                    <h2 style={{ display: 'none' }} id="dashboardTitle">
                        {dashboard.name}
                        <span style={{ fontSize: '22px', fontWeight: 600 }}>{surveyDash ? ` - ${scopeName}` : ''}</span>
                    </h2>
                    {!loadingScopeData
                        ? (
                            <div style={{ display: surveyDash ? 'none' : 'flex' }}>
                                <ScopeSelector
                                    appStore={DynamicDashboardStore.appStore}
                                    DynamicDashboardStore={DynamicDashboardStore}
                                    initialScope={DynamicDashboardStore.recordId || undefined}
                                    history={history}
                                />
                            </div>
                        )
                        : null}
                    {surveyDash && (
                        <Button
                            onClick={() => history.push('/company/dashboard/')}
                            icon="fa-light fa-gauge-simple-min"
                            cssClass="large secondary"
                            label={i18n.t('dashboards.allCompany')}
                            style={{ maxHeight: '40px' }}
                        />
                    )}
                </Panel>
            </Fragment>
        )
    }
}

export default DashboardHeader
